// client/src/pages/AboutPage.js
import React from 'react';
import usePublicOffice from '../hooks/usePublicOffice';

const AboutPage = () => {
    const { isFL, jurisdiction, office } = usePublicOffice();
    // Florida wording from data (audit 2026-10, H8); the Illinois sentence is unchanged.
    const where = isFL ? ((office && office.service_area) || (jurisdiction && jurisdiction.name) || 'Florida') : 'the Chicago metropolitan area';
    const law = isFL ? ((jurisdiction && jurisdiction.statute) || 'Florida real estate license law') : 'the Illinois Real Estate License Act';
    return (
    <div className="container mx-auto px-6 py-20">
        <div className="max-w-4xl mx-auto bg-white p-10 rounded-lg shadow-lg">
            <h1 className="text-4xl font-bold text-center mb-10">About Us</h1>
            <p className="text-lg text-gray-700 leading-relaxed">
                For over 20 years, Business Real Estate Corp. (BREC) has been a leader in the commercial real estate market. We provide a full suite of services for investors, owners, and tenants, ensuring every transaction is handled with the utmost professionalism and strategic insight. Our virtual office model allows us to provide agile, responsive service across {where} while maintaining full compliance with {law}.
            </p>
            <p className="mt-6 text-lg text-gray-700 leading-relaxed">
                Our mission is to build long-term relationships based on trust and exceptional results. We leverage cutting-edge technology and deep market analysis to provide our clients with a competitive advantage.
            </p>
        </div>
    </div>
    );
};

export default AboutPage;
